import ElementSvg from './ElementSvg.vue';

export { ElementSvg };
